module.exports = __webpack_public_path__ + "img/221.4fa71576.png";